export function filterDate(time) {
    if (time) {
        let times = time.split(" ");
        return times[0]
    }
}

export function ossUrlFilter(ossUrl, level = 'Q99') {
    return ossUrl + "?x-oss-process=style/" + level;
}

export function filterMoney(money) {
    return money == null ? null : ((money * 1).toFixed(2))
}

export function formatMoney(money) {
    if (money === null || money === "" || money === undefined) {
        return "";
    }
    let result = money * 1;
    return result.toFixed(2);
}

export function formatPercent(num) {
    return num ? (num + "%") : "";
}

export function formatToPercent(num) {
    return num ? ((num * 100).toFixed(2) + "%") : "";
}
